import { definitions } from '@luxuryescapes/contract-svc-lux-loyalty'

type ServerLoyaltyPendingPoints = definitions['pendingPoints']

function mapLoyaltyAccountPendingPoint(pendingPoint: ServerLoyaltyPendingPoints): App.LoyaltyAccountPendingPoints {
  return {
    createdAt: pendingPoint.createdAt,
    id: pendingPoint.id,
    orderId: pendingPoint.orderId,
    orderItemId: pendingPoint.itemId,
    points: pendingPoint.points,
    statusCredits: pendingPoint.statusCredits,
  }
}

export default mapLoyaltyAccountPendingPoint
